<template>
  <div v-if="pool.length" class="d-flex justify-center align-center flex-wrap">
    <div
      v-for="(slot, index) in slots"
      :key="index"
      class="logo-slot mx-6 my-3 d-flex align-center justify-center"
    >
      <img
        :src="slot.logo.src"
        :alt="`${slot.logo.alt} logo`"
        class="logo-img"
        :class="{ 'logo-img--hidden': !slot.visible }"
      />
    </div>
  </div>
</template>

<script>
const LOGO_POOL = [
  { id: "amzn", src: require("@/assets/amzn-logo.png"), alt: "Amazon" },
  { id: "appl", src: require("@/assets/appl-logo.png"), alt: "Apple" },
  { id: "goog", src: require("@/assets/goog-logo.png"), alt: "Google" },
  { id: "meta", src: require("@/assets/meta-logo.png"), alt: "Meta" },
  { id: "msft", src: require("@/assets/msft-logo.png"), alt: "Microsoft" },
  { id: "ntfx", src: require("@/assets/ntfx-logo.png"), alt: "Netflix" },
  { id: "atpc", src: require("@/assets/atpc-logo.png"), alt: "Anthropic" },
  { id: "uber", src: require("@/assets/uber-logo.png"), alt: "Uber" }
];

const VISIBLE_COUNT = 4;
const ROTATE_INTERVAL_MS = 5000;
const FADE_DURATION_MS = 400;

function shuffled(arr) {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}

function preloadLogos(pool) {
  pool.forEach((logo) => {
    const img = new Image();
    img.src = logo.src;
  });
}

export default {
  name: "CompanyLogoCarousel",
  data() {
    const pool = LOGO_POOL;
    const initial = shuffled(pool).slice(
      0,
      Math.min(VISIBLE_COUNT, pool.length)
    );
    return {
      pool,
      slots: initial.map((logo) => ({ logo, visible: true })),
      intervalId: null,
    };
  },
  created() {
    preloadLogos(this.pool);
  },
  mounted() {
    if (this.pool.length > this.slots.length) {
      this.intervalId = setInterval(this.rotateOneSlot, ROTATE_INTERVAL_MS);
    }
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    rotateOneSlot() {
      const visibleIds = this.slots.map((slot) => slot.logo.id);
      const candidates = this.pool.filter(
        (logo) => !visibleIds.includes(logo.id)
      );
      if (!candidates.length) {
        return;
      }
      const slotIndex = Math.floor(Math.random() * this.slots.length);
      const nextLogo =
        candidates[Math.floor(Math.random() * candidates.length)];
      const slot = this.slots[slotIndex];

      slot.visible = false;
      setTimeout(() => {
        slot.logo = nextLogo;
        slot.visible = true;
      }, FADE_DURATION_MS);
    },
  },
};
</script>

<style scoped>
.logo-slot {
  height: 60px;
  width: 140px;
}
.logo-img {
  max-height: 50px;
  max-width: 140px;
  object-fit: contain;
  opacity: 1;
  transition: opacity 0.4s ease;
}
.logo-img--hidden {
  opacity: 0;
}
</style>
